import React from "react";

export default function LikeIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-9.31019674359186 -9.31019674359186 200.60019674359185 200.59919674359185"
      width={size}
      height={size}
    >
      <linearGradient id="a_like" x1="47.061%" x2="47.061%" y1="-3.394%" y2="96.606%">
        <stop offset="0" stopColor="#37aeff" />
        <stop offset=".05" stopColor="#37aeff" />
        <stop offset="1" stopColor="#1861f7" />
      </linearGradient>
      <g fill="none">
        <path d="M0 95.645c0 52.823 42.822 95.644 95.645 95.644 52.823 0 95.644-42.821 95.644-95.644C191.29 42.822 148.468 0 95.645 0A95.617 95.617 0 0 0 0 95.645" fill="url(#a_like)" />
        <path d="M151.421 99.986a9.095 9.095 0 0 0-3.901-8.737 18.08 18.08 0 0 0 3.6-8.628c0-8.463-7.941-10.99-20.168-10.99-7.27.08-14.51.936-21.597 2.555.66-3.627 5.496-14.15 5.496-17.667 0-7.31-1.731-16.486-8.436-19.976a11.925 11.925 0 0 0-6.154-1.593c-2.68-.126-5.303.8-7.309 2.583a6.32 6.32 0 0 0-.742 3.681l1.21 13.738c0 10.99-16.899 24.729-16.899 40.528v33.136c0 5.88 7.886 10.056 19.234 10.056h31.46c8.243 0 10.084-1.428 12.2-5.275a7.583 7.583 0 0 0-.166-8.023 12.364 12.364 0 0 0 7.749-8.93c.487-2.412.118-4.92-1.044-7.089a9.48 9.48 0 0 0 5.495-9.369M48.743 80.945h9.836a8.243 8.243 0 0 1 8.243 8.243V135.1a8.243 8.243 0 0 1-8.243 8.242h-9.836a8.243 8.243 0 0 1-8.243-8.242V89.298a8.243 8.243 0 0 1 8.243-8.243" fill="#fff" />
      </g>
    </svg>
  );
}

export function LoveIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1497.8 1500"
      width={size}
      height={size}
    >
      <style>{`.st0_love{fill:#fff}.st1_love{fill:#ed5168}`}</style>
      <path className="st0_love" d="M541.7 1092.6H376.6c-13 0-23.6-10.6-23.6-23.6V689.9c0-13 10.6-23.6 23.6-23.6h165.1c13 0 23.6 10.6 23.6 23.6V1069c-.1 13-10.7 23.6-23.6 23.6zM622.9 1003.5V731.9c0-66.3 18.9-132.9 54.1-189.2 21.5-34.4 69.7-89.5 96.7-118 6-6.4 27.8-25.2 27.8-35.5 0-13.2 1.5-34.5 2-74.2.3-25.2 20.8-45.9 46-45.7h1.1c44.1.8 58.2 41.6 58.2 41.6s37.7 74.4 2.5 165.4c-29.7 76.9-35.7 83.1-35.7 83.1s-9.6 13.9 20.8 13.3c0 0 185.6-.8 192-.8 13.7 0 57.4 12.5 54.9 68.2-1.8 41.2-27.4 55.6-40.5 60.3-2.6.9-2.9 4.5-.5 5.9 13.4 7.8 40.8 27.5 40.2 57.7-.8 36.6-15.5 50.1-46.1 58.5-2.8.8-3.3 4.5-.8 5.9 11.6 6.6 31.5 22.7 30.3 55.3-1.2 33.2-25.2 44.9-38.3 48.9-2.6.8-3.1 4.2-.8 5.8 8.3 5.7 20.6 18.6 20 45.1-.3 14-5 24.2-10.9 31.5-9.3 11.5-23.9 17.5-38.7 17.6l-411.8.8c-.1.1-22.5.1-22.5-29.9z" />
      <ellipse className="st1_love" cx="748.9" cy="750" rx="748.9" ry="750" />
      <path className="st0_love" d="M748.9 541.9C715.4 338.7 318.4 323.2 318.4 628c0 270.1 430.5 519.1 430.5 519.1s430.5-252.3 430.5-519.1c0-304.8-397-289.3-430.5-86.1z" />
    </svg>
  );
}

export function HahaIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192 192"
      width={size}
      height={size}
    >
      <defs>
        <radialGradient id="a_haha" cy="0%" gradientTransform="matrix(0 1 -1.26314 0 .5 -.5)" r="100%">
          <stop offset="0" stopColor="#fce16b" />
          <stop offset=".11" stopColor="#fce16b" />
          <stop offset=".205" stopColor="#fce06a" />
          <stop offset=".288" stopColor="#fcdf69" />
          <stop offset=".36" stopColor="#fcdd68" />
          <stop offset=".424" stopColor="#fbda66" />
          <stop offset=".483" stopColor="#fbd764" />
          <stop offset=".537" stopColor="#fbd361" />
          <stop offset=".591" stopColor="#facf5e" />
          <stop offset=".644" stopColor="#fac959" />
          <stop offset=".701" stopColor="#f9c254" />
          <stop offset=".763" stopColor="#f8bb4e" />
          <stop offset=".832" stopColor="#f8b147" />
          <stop offset=".91" stopColor="#f7a73d" />
          <stop offset="1" stopColor="#f69a31" />
        </radialGradient>
        <radialGradient id="b_haha" cy="100%" gradientTransform="matrix(0 -1 1.136 0 -.636 1.5)" r="100%">
          <stop offset="0" stopColor="#83370e" />
          <stop offset=".226" stopColor="#83370e" />
          <stop offset="1" stopColor="#482213" />
        </radialGradient>
        <radialGradient id="c_haha" cy="0%" gradientTransform="matrix(0 1 -.7355 0 .5 -.5)" r="100%">
          <stop offset="0" stopColor="#f75b73" />
          <stop offset="1" stopColor="#c51f2d" />
        </radialGradient>
        <filter id="d_haha" height="116.4%" width="112.8%" x="-6.4%" y="-8.2%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
        <filter id="e_haha" height="116.4%" width="112.8%" x="-6.4%" y="-8.2%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
        <linearGradient id="f_haha" x1="85.463%" y1="19.628%" y2="80.372%">
          <stop offset="0" stopColor="#222845" />
          <stop offset=".086" stopColor="#222845" />
          <stop offset=".166" stopColor="#232946" />
          <stop offset=".239" stopColor="#232b48" />
          <stop offset=".308" stopColor="#242d4a" />
          <stop offset=".374" stopColor="#262f4c" />
          <stop offset=".438" stopColor="#27314e" />
          <stop offset=".5" stopColor="#283350" />
          <stop offset=".562" stopColor="#293552" />
          <stop offset=".626" stopColor="#2a3754" />
          <stop offset=".692" stopColor="#2b3956" />
          <stop offset=".761" stopColor="#2c3a58" />
          <stop offset=".834" stopColor="#2c3b59" />
          <stop offset=".914" stopColor="#2d3c5a" />
          <stop offset="1" stopColor="#2d3c5a" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="96" cy="96" fill="url(#a_haha)" r="96" />
        <path d="M96 166c38.66 0 64-31.34 64-70 0-.66-7-13-64-13S32 95.34 32 96c0 38.66 25.34 70 64 70z" fill="url(#b_haha)" />
        <path d="M52.272 148.44C60.808 139.232 77.192 133 96 133s35.192 6.231 43.728 15.44C128.75 159.368 113.785 166 96 166s-32.75-6.633-43.728-17.56z" fill="url(#c_haha)" />
        <path d="M143.907 39.169c-8.207 2.389-27.788 13.373-30.542 17.594s-.61 9.333 2.895 10.056c9.102 0 24.787 2.671 35.424 7.776 5.94 3.015 9.499-5.293 5.66-7.776-5.597-4.395-14.439-7.194-26.525-8.397.991-3.035 12.582-8.024 18.07-10.617 5.49-2.593 3.226-11.026-4.982-8.636z" fill="#fff3c5" filter="url(#d_haha)" opacity=".449" />
        <path d="M64.797 39.169C56.59 41.558 37.01 52.542 34.255 56.763s-.61 9.333 2.895 10.056c9.102 0 24.787 2.671 35.424 7.776 5.94 3.015 9.499-5.293 5.66-7.776-5.597-4.395-14.439-7.194-26.525-8.397.991-3.035 12.583-8.024 18.071-10.617 5.488-2.593 3.225-11.026-4.983-8.636z" fill="#fff3c5" filter="url(#e_haha)" opacity=".449" transform="matrix(-1 0 0 1 112.83 0)" />
        <g fill="url(#f_haha)">
          <path d="M143.907 35.169c-8.207 2.389-27.788 13.373-30.542 17.594s-.61 9.333 2.895 10.056c9.102 0 24.787 2.671 35.424 7.776 5.94 3.015 9.499-5.293 5.66-7.776-5.597-4.395-14.439-7.194-26.525-8.397.991-3.035 12.582-8.024 18.07-10.617 5.49-2.593 3.226-11.026-4.982-8.636zM48.032 35.169c8.208 2.389 27.789 13.373 30.543 17.594s.61 9.333-2.896 10.056c-9.101 0-24.786 2.671-35.423 7.776-5.94 3.015-9.499-5.293-5.66-7.776 5.597-4.395 14.438-7.194 26.525-8.397-.992-3.035-12.583-8.024-18.071-10.617-5.489-2.593-3.225-11.026 4.982-8.636z" />
        </g>
      </g>
    </svg>
  );
}

export function WowIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 192 192"
      width={size}
      height={size}
    >
      <defs>
        <radialGradient id="a_wow" cy="0%" gradientTransform="matrix(0 1 -1.26314 0 .5 -.5)" r="100%">
          <stop offset="0" stopColor="#fce16b" />
          <stop offset=".11" stopColor="#fce16b" />
          <stop offset=".205" stopColor="#fce06a" />
          <stop offset=".288" stopColor="#fcdf69" />
          <stop offset=".36" stopColor="#fcdd68" />
          <stop offset=".424" stopColor="#fbda66" />
          <stop offset=".483" stopColor="#fbd764" />
          <stop offset=".537" stopColor="#fbd361" />
          <stop offset=".591" stopColor="#facf5e" />
          <stop offset=".644" stopColor="#fac959" />
          <stop offset=".701" stopColor="#f9c254" />
          <stop offset=".763" stopColor="#f8bb4e" />
          <stop offset=".832" stopColor="#f8b147" />
          <stop offset=".91" stopColor="#f7a73d" />
          <stop offset="1" stopColor="#f69a31" />
        </radialGradient>
        <filter id="b_wow" height="142.9%" width="118.7%" x="-9.4%" y="-21.4%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
        <linearGradient id="c_wow" x1="10.909%" x2="85.942%" y1="55.621%" y2="50%">
          <stop offset="0" stopColor="#d06a00" />
          <stop offset=".51" stopColor="#e18000" />
          <stop offset="1" stopColor="#d47100" />
        </linearGradient>
        <linearGradient id="d_wow" x1="50%" x2="50%" y1="15.514%" y2="100%">
          <stop offset="0" stopColor="#d16c00" stopOpacity="0" />
          <stop offset="1" stopColor="#ce6600" />
        </linearGradient>
        <filter id="e_wow" height="142.9%" width="118.7%" x="-9.4%" y="-21.4%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
        <radialGradient id="f_wow" cx="47.795%" cy="72.401%" gradientTransform="matrix(-.13245 .79295 -.76649 -.08194 1.096 .404)" r="98.416%">
          <stop offset="0" stopColor="#3e4672" />
          <stop offset=".086" stopColor="#3e4671" />
          <stop offset=".166" stopColor="#3d446f" />
          <stop offset=".239" stopColor="#3b426c" />
          <stop offset=".308" stopColor="#394068" />
          <stop offset=".374" stopColor="#363c63" />
          <stop offset=".438" stopColor="#33395d" />
          <stop offset=".5" stopColor="#2f3556" />
          <stop offset=".562" stopColor="#2b304f" />
          <stop offset=".626" stopColor="#282b48" />
          <stop offset=".692" stopColor="#242640" />
          <stop offset=".761" stopColor="#202239" />
          <stop offset=".834" stopColor="#1c1d32" />
          <stop offset=".914" stopColor="#1a1a2e" />
          <stop offset="1" stopColor="#19192c" />
        </radialGradient>
        <ellipse id="g_wow" cx="136" cy="68" rx="16" ry="20" />
        <filter id="h_wow" height="107.5%" width="109.4%" x="-4.7%" y="-3.8%">
          <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1" />
          <feOffset dy="-1" in="shadowBlurInner1" result="shadowOffsetInner1" />
          <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
          <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0.0611930497 0 0 0 0 0.0583983323 0 0 0 0 0.111497962 0 0 0 0.53944493 0" />
        </filter>
        <ellipse id="i_wow" cx="56" cy="68" rx="16" ry="20" />
        <filter id="j_wow" height="107.5%" width="109.4%" x="-4.7%" y="-3.8%">
          <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1" />
          <feOffset dy="-1" in="shadowBlurInner1" result="shadowOffsetInner1" />
          <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
          <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0.0611930497 0 0 0 0 0.0583983323 0 0 0 0 0.111497962 0 0 0 0.53944493 0" />
        </filter>
        <filter id="k_wow" height="108.3%" width="110.7%" x="-5.4%" y="-4.2%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
        <linearGradient id="l_wow" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0" stopColor="#482314" />
          <stop offset=".084" stopColor="#492314" />
          <stop offset=".156" stopColor="#4d2414" />
          <stop offset=".219" stopColor="#512613" />
          <stop offset=".275" stopColor="#572813" />
          <stop offset=".327" stopColor="#5e2a12" />
          <stop offset=".378" stopColor="#642c12" />
          <stop offset=".429" stopColor="#6a2f11" />
          <stop offset=".483" stopColor="#703111" />
          <stop offset=".542" stopColor="#763310" />
          <stop offset=".608" stopColor="#7a350f" />
          <stop offset=".685" stopColor="#7e360f" />
          <stop offset=".775" stopColor="#81370e" />
          <stop offset=".879" stopColor="#83380e" />
          <stop offset="1" stopColor="#84380e" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="96" cy="96" fill="url(#a_wow)" r="96" />
        <path d="M130.727 36.305c-.226.219-.525.695-2.227.695-1.228 0-2.338-.009-3.728-1.554-1.39-1.546-.568-3.605-.5-3.72a16.764 16.764 0 0 1 .67-1.043 17.315 17.315 0 0 1 2.33-2.704C130.53 24.903 135.03 23 140 23s9.47 1.903 12.728 4.98c.87.822 1.653 1.728 2.331 2.704.313.45.425.586.87 1.392.445.807-.332 4.924-3.503 4.924-3.17 0-3.465-.994-3.607-1.233a8.934 8.934 0 0 0-.48-.725 9.365 9.365 0 0 0-1.272-1.404c-1.795-1.62-4.27-2.546-7.06-2.546s-5.28.926-7.074 2.546c-.474.428-.9.898-1.271 1.403-.338.46-.71 1.044-.935 1.264z" fill="#fff3c5" filter="url(#b_wow)" opacity=".449" />
        <path d="M130.413 34.946c.101-.098.19-.22.614-.826l.07-.1a9.865 9.865 0 0 1 1.536-1.753c1.91-1.724 4.53-2.675 7.409-2.675 2.876 0 5.484.949 7.395 2.675.5.45.949.947 1.34 1.479.182.248.351.503.507.765.333.56 1.151.989 3.178.989 2.244 0 3.996-2.78 3.065-4.182-.251-.455-.397-.699-.552-.929l-.038-.056c-.047-.07-.236-.339-.253-.363a16.815 16.815 0 0 0-2.264-2.627c-3.261-3.08-7.674-4.843-12.385-4.843s-9.123 1.763-12.384 4.843a16.815 16.815 0 0 0-2.913 3.637 1.27 1.27 0 0 0-.112.24c-.267.735-.17 1.715.601 2.954 1.403 2.173 4.14 1.79 5.186.772z" fill="url(#c_wow)" stroke="url(#d_wow)" transform="matrix(-1 0 0 1 280.27 0)" />
        <path d="M42.682 36.305c-.225.219-.524.695-2.227.695-1.228 0-2.338-.009-3.728-1.554-1.39-1.546-.567-3.605-.499-3.72a16.764 16.764 0 0 1 .67-1.043 17.315 17.315 0 0 1 2.33-2.704C42.484 24.903 46.984 23 51.954 23c4.971 0 9.471 1.903 12.728 4.98.871.822 1.653 1.728 2.332 2.704.312.45.425.586.87 1.392.445.807-.333 4.924-3.503 4.924s-3.465-.994-3.608-1.233a8.934 8.934 0 0 0-.48-.725 9.365 9.365 0 0 0-1.272-1.404c-1.794-1.62-4.27-2.546-7.06-2.546s-5.279.926-7.073 2.546c-.475.428-.9.898-1.272 1.403-.338.46-.71 1.044-.935 1.264z" fill="#fff3c5" filter="url(#e_wow)" opacity=".449" transform="matrix(-1 0 0 1 103.924 0)" />
        <path d="M42.147 34.946c.101-.098.19-.22.614-.826l.07-.1a9.865 9.865 0 0 1 1.536-1.753c1.91-1.724 4.53-2.675 7.409-2.675 2.876 0 5.483.949 7.395 2.675.5.45.948.947 1.34 1.479.182.248.35.503.507.765.332.56 1.15.989 3.177.989 2.244 0 3.996-2.78 3.065-4.182-.25-.455-.396-.699-.551-.929l-.038-.056-.253-.363a16.815 16.815 0 0 0-2.265-2.627c-3.26-3.08-7.673-4.843-12.384-4.843s-9.123 1.763-12.385 4.843a16.815 16.815 0 0 0-2.912 3.637 1.27 1.27 0 0 0-.112.24c-.267.735-.17 1.715.6 2.954 1.404 2.173 4.14 1.79 5.187.772z" fill="url(#c_wow)" stroke="url(#d_wow)" transform="matrix(-1 0 0 1 103.738 0)" />
        <use fill="url(#f_wow)" href="#g_wow" />
        <use fill="#000" filter="url(#h_wow)" href="#g_wow" />
        <ellipse cx="133" cy="61" fill="#595e7c" rx="5" ry="6" transform="rotate(8 133 61)" />
        <use fill="url(#f_wow)" href="#i_wow" />
        <use fill="#000" filter="url(#j_wow)" href="#i_wow" />
        <ellipse cx="53" cy="61" fill="#595e7c" rx="5" ry="6" transform="rotate(8 53 61)" />
        <path d="M97 173c22.06-.667 28-16.118 28-36 0-17.882-10.536-36-28-36s-28 18.118-28 36c0 18.882 5.94 36.667 28 36z" fill="#fff3c5" filter="url(#k_wow)" opacity=".449" />
        <path d="M97 172c22.06-.667 28-16.118 28-36 0-17.882-10.536-36-28-36s-28 18.118-28 36c0 18.882 5.94 36.667 28 36z" fill="url(#l_wow)" />
      </g>
    </svg>
  );
}

export function SadIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width={size}
      height={size}
    >
      <style>{`.st0_sad{fill:#ffda6b}.st1_sad{fill:#262c38}.st2_sad{fill:none;stroke:#262c38;stroke-width:60;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st3_sad{fill:#6485c3}`}</style>
      <ellipse className="st0_sad" cx="750.6" cy="745.9" rx="750" ry="745.8" />
      <path className="st1_sad" d="M508.2 802.6c0 51.4-42.5 102.3-94.2 102.3s-93.1-50.9-93.1-102.3 42.5-106.7 94.2-106.7c51.8 0 93.1 55.2 93.1 106.7zM1177.8 802.6c0 51.4-42.5 102.3-94.2 102.3s-93.1-50.9-93.1-102.3 42.5-106.7 94.2-106.7 93.1 55.2 93.1 106.7z" />
      <path className="st2_sad" d="M287.9 647.6s44-106.8 172.4-83.9M1213.9 647.6s-44-106.8-172.4-83.9M571.6 1174s172.4-183.2 356.6 0" />
      <path className="st3_sad" d="M1287.1 1329s-46.5-145.5-98.7-230.3l-2.8 5c0-.1 0-.1 0 0 0 0-52.9 97.7-98.6 219.1-8.8 23.3-13.3 48.1-11.8 73 2.7 45.7 24.8 104.4 120.4 104.4.1 0 141.4-9 91.5-171.2z" />
    </svg>
  );
}

export function AngryIcon({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width={size}
      height={size}
    >
      <style>{`.st0_angry{fill:url(#SVGID_1_angry)}.st1_angry{fill:#262c38}.st2_angry{fill:none;stroke:#262c38;stroke-width:60;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}`}</style>
      <linearGradient id="SVGID_1_angry" gradientUnits="userSpaceOnUse" x1="750" y1="1501.519" x2="750" y2="4.759" gradientTransform="matrix(1 0 0 -1 0 1499.72)">
        <stop offset=".098" stopColor="#f05766" />
        <stop offset=".25" stopColor="#f3766a" />
        <stop offset=".826" stopColor="#ffda6b" />
      </linearGradient>
      <circle className="st0_angry" cx="750" cy="750" r="750" />
      <circle className="st1_angry" cx="416.7" cy="947" r="73.7" />
      <circle className="st1_angry" cx="1082.7" cy="947" r="73.7" />
      <path className="st2_angry" d="M205.9 805.1s120.5 93.7 423.4 93.7M1291.9 805.1s-120.5 93.7-423.4 93.7" />
      <path className="st1_angry" d="M987.6 1211.4c0 41.7-106.7 43.3-238.4 43.3s-238.4-1.7-238.4-43.3c0-36.8 109.9-54.6 241.5-54.6s235.3 17.7 235.3 54.6z" />
    </svg>
  );
}

// Helper function để get icon component theo type
export function getReactionIcon(type) {
  const iconMap = {
    LIKE: LikeIcon,
    LOVE: LoveIcon,
    HAHA: HahaIcon,
    WOW: WowIcon,
    SAD: SadIcon,
    ANGRY: AngryIcon,
  };
  return iconMap[type] || LikeIcon;
}

